export default {
  APP_STARTED: "app/STARTED",
  APP_STARTED_SUCCESS: "app/STARTED_SUCCESS",
  APP_STARTED_FAILURE: "app/STARTED_FAILURE"
};
